import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { verifyUser } from '../actions/formActions';
import { Alert, Container, Col, Row } from 'reactstrap';
import Base from './Base';
import { Redirect } from 'react-router-dom';
import NotFound from './NotFound';
import Spinner from './Spinner';

const AccountVerified = (props: any) => {
  const { auth, errors, match, history } = props;

  useEffect(() => {
    props.verifyUser(match.params.code);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prevVerifiedRef = useRef(auth.verified);
  useEffect(() => {
    if (auth.verified !== prevVerifiedRef.current) {
      prevVerifiedRef.current = auth.verified;
      setTimeout(() => {
        history.push('/login');
      }, 3000);
    }
  }, [auth.verified, history]);

  if (match.params.code.length < 16) {
    return <Redirect to="/" />;
  }

  return (
    <React.Fragment>
      {auth.verified !== null && (
        <React.Fragment>
          <Base title={`Welcome Back`} />
          <Container className="mt-5" style={{ minHeight: '30vh' }}>
            <Row>
              <Col className="  py-auto">
                <h4 className="font-weight-light mb-3 text-center ">Thank you for signing up !</h4>
                <Alert>
                  Congratulations, your account has been verified. You are being redirected to login
                  page.
                </Alert>
              </Col>
            </Row>
          </Container>
        </React.Fragment>
      )}

      {!errors.code ? (
        <div className="text-center" style={{ minHeight: '50vh' }}>
          <Spinner />
        </div>
      ) : (
        <NotFound />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  errors: state.errors,
  auth: state.form,
});

export default connect(mapStateToProps, { verifyUser })(AccountVerified);
